import React, { useEffect } from "react";
import { Box, Avatar, Typography } from "@mui/material";
import Icon1 from "../icons/Icon";
import { useTheme } from "@mui/material";
import SecondaryButton from "../buttons/SecondaryButton";
import { BorderAllRounded, Photo } from "@mui/icons-material";
import { useState } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import UploadMultiPDF from "../api/upload/UploadMultiPDF";
import deleteFolderFile from "../api/delete/deleteFolderFile";
import UploadModifThermal from "../api/upload/UploadModifThermal";
import UploadThermal from "../api/upload/UploadThermal";
import { doc } from "firebase/firestore";
import UploadRapport from "../api/upload/UploadRapport";
import UploadRapportArchi from "../api/upload/UploadRapportArchi";
import PDFModal from "../pdf/PDFModal";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import XmlModal from "../xml/XmlModal";
import PreSignXmlModal from "../sign/PreSignXmlModal";
import SignModal from "../sign/SignModal";
import UploadTheXml from "../api/upload/UploadTheXml";
import { useAppContext } from "../config/AppContext";
import PdfEditorModal from "../sign/model/SignModal";
import PhotoModal from "../photo/PhotoModal";
import { useSnackbar } from "notistack";
import Spinner from "../loading/Spinner";
import SmallSpinner from "../loading/SmallSpinner";
import downloadMultiPDF from "../api/download/downloadMultiPDF";
import downloadFile from "../api/download/downloadFile";
import downloadPhotos from "../api/download/downloadPhotos";
import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  listenDocDataByRef,
  updateDocDataField,
} from "../models/DataFunctions";
import UploadXml2 from "../api/upload/UploadXml2";
import getTemporaryUrl from "../api/getTemporaryUrl";
import generateEtudeThermique from "../api/xml/generateEtudeThermique";
import Modal1 from "../modals/Modal1";
import WarningButton from "../buttons/WarningButton";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { color } from "echarts";
import GenerateATHSPE from "../folder_modals/GenerateATHSPE";
import Tippy from "@tippyjs/react";
import { translateDocumentId } from "../pages/folder_pages/FolderV2";
import { addActivityLog } from "../config/OnlineStatus";
import refreshCounters from "../api/refreshCounters";
import { isFolderAdmin } from "../pages/folder_pages/FolderHelpers";
import { isFolderClient } from "../hexagone/VisibilityHelpers";
import PrimaryButton from "../buttons/PrimaryButton";
import TextField2 from "../textfields/TextField2";

const DocumentCell = ({
  document,
  removable,
  orgData,
  userData,
  dropped_exists,
  onUpdate,
  folder,
  transferFiles,
  handleAskExpert,
  loadingTransfer,
  setLoadingTransfer,
  overrideId,
  navigateWorkspace,
}) => {
  const { currentUser, loading } = useAuth();
  const [type, setType] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [documentDocData, setDocumentDocData] = useState(null);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [Unsubscribe, setUnsubscribe] = useState(null);

  const [loadingData, setLoadingData] = useState(null);
  const [loadingEtude, setLoadingEtude] = useState(false);

  const fetchTokenAndSetType = async () => {
    handleType();
  };

  const handleTransferFiles = async (docId) => {
    setLoadingTransfer(docId);
    await transferFiles(docId);
    setLoadingTransfer(null);
    if (document.icon === "sign" && isFolderAdmin(orgData, folder)) {
      await updateDocDataFieldApi(document.ref, "state", "done", prefix);
    }
  };

  useEffect(() => {
    fetchTokenAndSetType();
    setDescriptionValue(document.description || "");
    if (
      document &&
      document.id != "thermal" &&
      document.id != "xml" &&
      document.id != "modif_thermal" &&
      document.id != "modif_thermal_xml" &&
      document.id != "rapport" &&
      document.id != "rapport_architecte"
    ) {
      const newUnsubscribe = listenDocDataByRef(
        document?.ref,
        setDocumentDocData
      );
      setUnsubscribe(() => newUnsubscribe);
    }

    return () => {
      // Cleanup on unmount or when document changes
      if (Unsubscribe) {
        Unsubscribe();
      }
    };
  }, [document, loadingTransfer]);

  const handleType = () => {
    if (document.id == "thermal") {
      setType("thermal");
    } else if (document.id == "modif_thermal") {
      setType("modif_thermal");
    } else if (document.id == "modif_thermal_xml") {
      setType("modif_thermal_xml");
    } else if (document.id == "xml") {
      setType("xml");
    } else if (document.id == "rapport") {
      setType("rapport");
    } else if (document.id == "rapport_architecte") {
      setType("rapport_architecte");
    } else if (document.icon == "photo" && document.id == "modif_thermal") {
      setType("photo_modif_thermal");
    } else if (document.icon == "photo") {
      setType("photo");
    } else {
      setType("doc");
    }
  };

  const sendLockedNotif = () => {
    handleClickVariant(
      "Les rapports doivent être réglés avant de pouvoir être débloqués",
      "error"
    );
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  // Generate (or re-open) the full RE2020 RSET thermal study PDF from the XML,
  // rendered server-side via the official CSTB XSL, then open it in a new tab.
  // Works for both the original XML and the mise-à-jour XML (modif_thermal.xml).
  const isModifXml = document.id === "modif_thermal_xml";
  const etudeXmlSlot = isModifXml ? folder?.modif_thermal?.xml : folder?.xml;
  const handleGenerateEtude = async () => {
    if (loadingEtude) return;
    const fileId = etudeXmlSlot?.file?.id;
    if (!fileId) {
      handleClickVariant("Aucun fichier XML à convertir.", "error");
      return;
    }
    setLoadingEtude(true);
    try {
      const token = await getOrRefreshFirebaseToken();
      const result = await generateEtudeThermique(
        folder.id,
        fileId,
        token,
        prefix,
        isModifXml
      );
      if (result.success && result.file?.url) {
        window.open(result.file.url, "_blank", "noopener,noreferrer");
      } else {
        handleClickVariant(
          result.message || "Impossible de générer l'étude thermique.",
          "error"
        );
      }
    } catch (e) {
      handleClickVariant("Impossible de générer l'étude thermique.", "error");
    } finally {
      setLoadingEtude(false);
    }
  };

  const handleDeleteFile = async (file) => {
    setDeleteOpen(false);
    setLoadingTransferDelete(document.id);
    const token = await getOrRefreshFirebaseToken();
    if (
      document.id == "thermal" ||
      document.id == "modif_thermal" ||
      document.id == "modif_thermal_xml" ||
      document.id == "xml" ||
      document.id == "rapport" ||
      document.id == "rapport_architecte"
    ) {
      await deleteFolderFile(
        folder.id,
        token,
        document.id,
        document.id,
        file ? file.id : "vide",
        prefix
      );

      if (document.id === "xml" && folder.last_file_extracted?.id) {
        await updateDocDataFieldApi(
          folder.ref,
          "last_file_extracted",
          null,
          prefix
        );
        await updateDocDataFieldApi(
          folder.ref,
          "last_file_extracted_sign_coords",
          null,
          prefix
        );
      }
    } else {
      await deleteFolderFile(
        folder.id,
        token,
        "doc",
        document.id,
        file ? file.id : "vide",
        prefix
      );
    }
    let repo_name = await translateDocumentId(document.id);
    await addActivityLog(
      "Documents supprimés " + repo_name,
      folder.ref,
      orgData.id,
      userData.id,
      "file_deleted",
      prefix
    );
    onUpdate();
    setLoadingTransferDelete(null);
  };
  const theme = useTheme();

  const state_background_color = () => {
    let state = document.state;
    if (documentDocData) {
      state = documentDocData.state;
    }

    if (state === "wait") {
      return theme.palette.accent3.light;
    } else if (state === "done") {
      return theme.palette.accent1.light;
    } else if (state === "missing") {
      return theme.palette.accent2.light;
    } else if (state === "open") {
      return theme.palette.primary.l2;
    } else if (state === "blocked") {
      return "#fc373a";
    } else {
      return theme.palette.shadow._5;
    }
  };

  const action_background_color = () => {
    let state = document.state;
    if (documentDocData) {
      state = documentDocData.state;
    }
    if (isFolderAdmin(orgData, folder)) {
      if (state === "wait") {
        return theme.palette.primary.main;
      } else if (state === "done") {
        return theme.palette.forever.white;
      } else if (state === "missing") {
        return theme.palette.forever.white;
      } else if (state === "open") {
        return theme.palette.forever.white;
      } else {
        return theme.palette.forever.white;
      }
    } else if (isFolderClient(orgData, folder)) {
      if (state === "wait") {
        return theme.palette.forever.white;
      } else if (state === "done") {
        return theme.palette.forever.white;
      } else if (state === "missing") {
        return theme.palette.primary.main;
      } else if (state === "open") {
        return theme.palette.primary.main;
      } else {
        return theme.palette.primary.main;
      }
    }
  };

  const action_text_color = () => {
    let state = document.state;
    if (documentDocData) {
      state = documentDocData.state;
    }
    if (isFolderAdmin(orgData, folder)) {
      if (state === "wait") {
        return theme.palette.forever.white;
      } else if (state === "done") {
        return theme.palette.shadow._50;
      } else if (state === "missing") {
        return theme.palette.shadow._50;
      } else if (state === "open") {
        return theme.palette.shadow._50;
      } else {
        return theme.palette.shadow._50;
      }
    } else if (orgData.id === folder.client_id) {
      if (state === "wait") {
        return theme.palette.shadow._50;
      } else if (state === "done") {
        return theme.palette.shadow._50;
      } else if (state === "missing") {
        return theme.palette.forever.white;
      } else if (state === "open") {
        return theme.palette.forever.white;
      } else {
        return theme.palette.forever.white;
      }
    }
  };

  const isFolderBlocked = async () => {
    // look if any state is blocked
    let updated_folder = await getDocDataByRef(folder.ref);
    let documents = await getArrayDocDataByRef(folder.documents);
    let blocked = false;
    if (
      updated_folder.thermal.state === "blocked" ||
      updated_folder.xml.state === "blocked" ||
      updated_folder.modif_thermal.state === "blocked" ||
      updated_folder.rapport.state === "blocked" ||
      updated_folder.rapport_architecte.state === "blocked"
    ) {
      blocked = true;
    }
    documents.forEach((doc) => {
      if (doc.state === "blocked") {
        blocked = true;
      }
    });
    return blocked;
  };

  const handleBlock = async () => {
    let actual_state = document.state;
    let new_state = "";
    if (actual_state === "blocked") {
      if (document.files?.length > 0) {
        new_state = "wait";
      } else {
        new_state = "locked";
      }
      handleClickVariant("Document débloqué", "success");
    } else {
      new_state = "blocked";
      handleClickVariant("Document bloqué", "success");
    }

    if (document.id === "xml") {
      await updateDocDataFieldApi(folder.ref, "xml.state", new_state, prefix);
    } else if (document.id === "modif_thermal_xml") {
      await updateDocDataFieldApi(
        folder.ref,
        "modif_thermal.xml.state",
        new_state,
        prefix
      );
    } else if (document.id === "thermal") {
      await updateDocDataFieldApi(
        folder.ref,
        "thermal.state",
        new_state,
        prefix
      );
    } else if (document.id === "modif_thermal") {
      await updateDocDataFieldApi(
        folder.ref,
        "modif_thermal.state",
        new_state,
        prefix
      );
    } else if (document.id === "rapport") {
      await updateDocDataFieldApi(
        folder.ref,
        "rapport.state",
        new_state,
        prefix
      );
    } else if (document.id === "rapport_architecte") {
      await updateDocDataFieldApi(
        folder.ref,
        "rapport_architecte.state",
        new_state,
        prefix
      );
    } else {
      await updateDocDataFieldApi(document.ref, "state", new_state, prefix);
    }

    let still_blocked = await isFolderBlocked();

    await updateDocDataFieldApi(folder.ref, "blocked", still_blocked, prefix);

    actionRefreshCounters();
    onUpdate();
  };

  const actionRefreshCounters = async () => {
    const token = await getOrRefreshFirebaseToken();
    await refreshCounters(token, folder.id, prefix);
    handleClickVariant("Actions mises à jour", "success");
  };

  const handleValidate = async () => {
    let actual_state = document.state;

    let new_state = "";
    if (actual_state === "done") {
      new_state = "locked";
    } else {
      new_state = "done";
    }
    if (document.id === "xml") {
      await updateDocDataFieldApi(folder.ref, "xml.state", new_state, prefix);
    } else if (document.id === "modif_thermal_xml") {
      await updateDocDataFieldApi(
        folder.ref,
        "modif_thermal.xml.state",
        new_state,
        prefix
      );
    } else if (document.id === "thermal") {
      await updateDocDataFieldApi(
        folder.ref,
        "thermal.state",
        new_state,
        prefix
      );
    } else if (document.id === "modif_thermal") {
      await updateDocDataFieldApi(
        folder.ref,
        "modif_thermal.state",
        new_state,
        prefix
      );
    } else if (document.id === "rapport") {
      await updateDocDataFieldApi(
        folder.ref,
        "rapport.state",
        new_state,
        prefix
      );
    } else if (document.id === "rapport_architecte") {
      await updateDocDataFieldApi(
        folder.ref,
        "rapport_architecte.state",
        new_state,
        prefix
      );
    } else {
      await updateDocDataFieldApi(document.ref, "state", new_state, prefix);
    }
    onUpdate();
    actionRefreshCounters();
  };

  const [loadingDataDelete, setLoadingTransferDelete] = useState(null);

  const state_text = () => {
    let state = document.state;
    if (documentDocData) {
      state = documentDocData.state;
    }
    if (state === "wait") {
      return "En attente";
    }
    if (state === "done") {
      return "Validé";
    }
    if (state === "missing") {
      return "Refusé";
    }
    if (state === "open") {
      return "Prêt";
    }
    if (state === "blocked") {
      return "Bloqué";
    }
    return "Vide";
  };

  function getFilesNames() {
    let names = [];
    if (type == "doc") {
      names = document.files?.map((file) => file.name);
      return names || [];
    } else if (type == "thermal") {
      names = folder.thermal.files?.map((file) => file.name);
      return names || [];
    } else if (type == "modif_thermal") {
      names = folder.modif_thermal.files?.map((file) => file.name);
      return names || [];
    } else if (type == "rapport") {
      names = folder.rapport.files?.map((file) => file.name);
      return names || [];
    } else if (type == "rapport_architecte") {
      names = folder.rapport_architecte.files?.map((file) => file.name);
      return names || [];
    } else if (type == "xml") {
      names = [folder.xml.file?.name];
      return names || [];
    } else if (type == "modif_thermal_xml") {
      names = [folder.modif_thermal?.xml?.file?.name];
      return names || [];
    }
    return names || [];
  }

  function checkHasAction() {
    if (document.state === "wait" && isFolderAdmin(orgData, folder)) {
      return true;
    }
    if (
      type === "xml" &&
      document.state !== "done" &&
      document.state !== "wait" &&
      folder.author_id !== orgData.id &&
      isFolderClient(orgData, folder) &&
      !folder.xml.requested
    ) {
      return true;
    }
    if (
      type === "thermal" &&
      document.state !== "done" &&
      folder.author_id === orgData.id &&
      document.state !== "wait" &&
      isFolderClient(orgData, folder)
    ) {
      return true;
    }
    if (
      type === "doc" &&
      document.icon === "sign" &&
      document.state === "open" &&
      isFolderClient(orgData, folder)
    ) {
      return true;
    }
    if (
      type === "doc" &&
      document.icon === "file" &&
      document.state === "locked" &&
      isFolderClient(orgData, folder) &&
      folder.author_id !== orgData.id
    ) {
      return true;
    }
    if (
      document.icon === "photo" &&
      document.state === "open" &&
      isFolderClient(orgData, folder)
    ) {
      return true;
    }
    if (
      document.icon === "file" &&
      document.state === "open" &&
      isFolderClient(orgData, folder)
    ) {
      return true;
    }
    return false;
  }

  function checkIsViewer() {
    if (isFolderAdmin(orgData, folder)) {
      return true;
    }
    if (type === "doc") {
      return document.viewers_id?.includes(orgData.id);
    } else if (type === "thermal" || type === "xml") {
      return folder.thermal.viewers_id?.includes(orgData.id);
    } else if (type === "modif_thermal" || type === "modif_thermal_xml") {
      return folder.modif_thermal.viewers_id?.includes(orgData.id);
    } else if (type === "rapport") {
      return true;
    } else if (type === "rapport_architecte") {
      return true;
    }
  }

  const action_text = () => {
    let state = document.state;

    if (documentDocData) {
      state = documentDocData.state;
    }
    if (state === "blocked") {
      return "";
    }
    const icon = document.icon;
    const dropped = dropped_exists;
    if (dropped) {
      if (icon !== "photo") {
        return "Transférer ici";
      } else {
        return "none";
      }
    }
    if (isFolderAdmin(orgData, folder)) {
      if (state === "wait") {
        return "Vérifier";
      }
      if (state === "done" && getFilesNames()?.length > 0) {
        return "Ouvrir";
      }
      if (state === "missing") {
        return "Ajouter";
      }

      if (state === "open" && icon !== "photo") {
        return "Ouvrir";
      }
      if (state === "locked") {
        if (icon === "file") {
          return "Ajouter";
        } else if (icon === "photo" || icon === "sign") {
          return "Préparer";
        }
      }
      return "Ajouter";
    } else if (!isFolderAdmin(orgData, folder)) {
      if (state === "wait") {
        return "Ouvrir";
      }
      if (state === "done") {
        if (icon === "xml") {
          return "Extraire";
        } else {
          return "Ouvrir";
        }
      }
      if (state === "missing") {
        return "Ajouter";
      }
      if (state === "open" && icon === "sign") {
        return "Signer";
      }
      if (state === "open" && icon === "photo") {
        return "Déposer";
      }
      if (state === "locked") {
        if (icon === "file") {
          return "Ajouter";
        } else if (icon === "photo" || icon === "sign") {
          return "none";
        }
      }
      return "Ajouter";
    }
  };
  const handleDownload = async () => {
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "all", "", folder.id, prefix);
    let fresh_folder = await getDocDataByRef(folder.ref);
    if (type == "photo") {
      await downloadPhotos(document.ref, fresh_folder.nom);
    } else {
      let files = document;
      if (document.state !== "missing" || document.state !== "locked") {
        if (type === "thermal") {
          files = fresh_folder.thermal.files;
        } else if (type === "modif_thermal") {
          files = fresh_folder.modif_thermal.files;
        } else if (type === "rapport") {
          files = fresh_folder.rapport.files;
        } else if (type === "rapport_architecte") {
          files = fresh_folder.rapport_architecte.files;
        } else if (type === "xml") {
          files = [fresh_folder.xml.file];
        } else if (type === "modif_thermal_xml") {
          files = [fresh_folder.modif_thermal?.xml?.file];
        } else {
          let fresh_document = await getDocDataByRef(document.ref);

          files = fresh_document.files;
        }

        if (files.length > 1) {
          downloadMultiPDF(files, getName(type, document), folder.nom);
        } else {
          downloadFile(files[0]);
        }
      }
    }
    handleClickVariant("Téléchargement en cours", "success");
  };

  function getName(type, document) {
    if (type === "thermal") {
      return "Documents_Etude_Thermique";
    } else if (type === "modif_thermal") {
      return "Documents_Modifications_Thermique";
    } else if (type === "rapport") {
      return "Documents_Rapport";
    } else if (type === "rapport_architecte") {
      return "Documents_Rapport_Architecte";
    } else if (type === "xml") {
      return "Fichier_XML";
    } else {
      return document.name;
    }
  }

  const [onDownloadHover, setDownloadHover] = useState(false);

  const [isHover, setHover] = useState(false);

  const [descriptionEditing, setDescriptionEditing] = useState(false);
  const [descriptionValue, setDescriptionValue] = useState(
    document.description || ""
  );
  const [tippyVisible, setTippyVisible] = useState(false);
  const [tippyInstance, setTippyInstance] = useState(null);

  useEffect(() => {
    if (tippyVisible) {
      setTimeout(() => {
        const textarea = window.document.querySelector(".description-textarea");
        if (textarea) {
          textarea.style.height = "auto";
          textarea.style.height = textarea.scrollHeight + "px";
        }
      }, 10);
    }
  }, [tippyVisible, descriptionValue]);

  const handleDescriptionSave = async (showNotification = true) => {
    if (!descriptionValue || !document?.ref) return;
    if (descriptionValue !== document.description) {
      await updateDocDataFieldApi(
        document.ref,
        "description",
        descriptionValue,
        prefix
      );
      if (showNotification) {
        handleClickVariant("Description mise à jour", "success");
      }
      onUpdate();
    }
    setDescriptionEditing(false);
  };

  const state_color = () => {
    let state = document.state;
    if (documentDocData) {
      state = documentDocData.state;
    }
    if (state === "wait") {
      return theme.palette.accent3.main;
    } else if (!state || state === "locked") {
      return "grey";
    } else if (state === "done") {
      return theme.palette.accent1.main;
    } else if (state === "missing") {
      return theme.palette.accent2.main;
    } else if (state === "open") {
      return theme.palette.primary.light;
    } else if (state === "blocked") {
      return "white";
    } else {
      return theme.palette.forever.black;
    }
  };
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [generateATHSPEOpen, setGenerateATHSPEOpen] = useState(false);
  if (type == null) return null;

  return (
    <div
      className={`flex flex-row relative items-start justify-between overflow-auto rounded-lg align-top p-1 hover:bg-slate-50 max-w-full w-full ${true ? "" : ""}`}
    >
      <Modal1
        isOpen={generateATHSPEOpen}
        onClose={() => setGenerateATHSPEOpen(false)}
      >
        <GenerateATHSPE
          folder={folder}
          orgData={orgData}
          userData={userData}
          document={document}
          onClose={() => setGenerateATHSPEOpen(false)}
          onUpdate={onUpdate}
        ></GenerateATHSPE>
      </Modal1>
      <Modal1 isOpen={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <div className=" flex flex-col bg-white rounded-xl p-4">
          <div className="text-h2">
            Voulez-vous vraiment supprimer cet élément ?
          </div>
          <div className="text-h3 text-shadow_50 my-4">
            Cette action est irréversible. Elle entraîne la suppression
            définitive de ces éléments.
          </div>
          <div className="text-h3 text-shadow_50 ">- Fichiers déposés</div>

          {!loadingDelete && (
            <div className="flex flex-row justify-end gap-2 ">
              <SecondaryButton onClick={() => setDeleteOpen(false)}>
                Annuler
              </SecondaryButton>
              <WarningButton onClick={handleDeleteFile}>
                Supprimer
              </WarningButton>
            </div>
          )}
          {loadingDelete && <SmallSpinner></SmallSpinner>}
        </div>
      </Modal1>
      {/* User Avatar and Email */}
      <div className={`flex flex-row gap-3 items-start text-h3 max-w-full  `}>
        {document.id !== "xml" && document.id !== "rapport" && (
          <div className="w-c250 flex flex-row items-center gap-1">
            <span className="" style={{ zIndex: 5 }}>
              {document.name}
            </span>
            {(document.description || isFolderAdmin(orgData, folder)) && (
              <Tippy
                content={
                  <div
                    className="rounded-lg shadow-xl p-2 bg-black"
                    style={{
                      minWidth: "250px",
                      maxWidth: "350px",
                      maxHeight: "none",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {isFolderAdmin(orgData, folder) ? (
                      <textarea
                        placeholder="Ajouter une description..."
                        value={descriptionValue}
                        onChange={(e) => {
                          setDescriptionValue(e.target.value);
                        }}
                        onInput={(e) => {
                          e.target.style.height = "auto";
                          e.target.style.height = e.target.scrollHeight + "px";
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleDescriptionSave();
                          }
                        }}
                        className="description-textarea w-full h-full px-1 py-1 text-xs bg-inherit text-white border border-gray-600 rounded focus:outline-none focus:border-grey-600 resize-none overflow-hidden"
                        autoFocus
                        rows={1}
                        style={{ maxHeight: "none" }}
                        ref={(el) => {
                          if (el) {
                            el.style.height = "auto";
                            el.style.height = el.scrollHeight + "px";
                          }
                        }}
                      />
                    ) : (
                      <div className="text-xs text-white whitespace-pre-wrap">
                        {document.description}
                      </div>
                    )}
                  </div>
                }
                interactive={true}
                visible={tippyVisible}
                onClickOutside={() => {
                  if (descriptionValue !== document.description) {
                    handleDescriptionSave(false);
                  }
                  setTippyVisible(false);
                }}
                onCreate={(instance) => setTippyInstance(instance)}
                onHide={() => {
                  // Only allow hide if instance is not destroyed
                  return tippyInstance?.state?.isDestroyed !== true;
                }}
                placement="right"
                appendTo={() => window.document.body}
                popperOptions={{
                  strategy: "fixed",
                }}
              >
                <div
                  onClick={() => setTippyVisible(!tippyVisible)}
                  style={{ cursor: "pointer" }}
                  className="ml-auto"
                >
                  <Icon1 icon_name="question" size={16} fill="grey" />
                </div>
              </Tippy>
            )}
            {!document.documentxx &&
              !["Documents étude thermique"].includes(document.name) && (
                <div className="">
                  <Icon1 icon_name="warning" size={16} fill="orange" />
                </div>
              )}
          </div>
        )}
        {document.id === "xml" && (
          <div className="w-c200 flex flex-col">
            <div className="w-c200 flex flex-col">XML RE2020 (.zip)</div>
            <div className="w-c200 flex flex-col">
              XML RT2012 (.zip ou .xml)
            </div>
          </div>
        )}
        {document.id === "rapport" && (
          <div className=" flex flex-row w-c400 gap-2">
            <div className="flex ">Rapports de fin de chantier </div>
            <div className="text-red-500"> (ne pas utiliser)</div>
          </div>
        )}
        <div className=" flex flex-col max-w-full ">
          {getFilesNames().length > 0 &&
            getFilesNames().map((name, index) => {
              return (
                <div
                  key={name + index.toString()}
                  className="flex flex-row items-center  max-w-full"
                >
                  <div className="text-h5 text-shadow_50 h-4 hidden lg:flex overflow-hidden  text-ellipsis max-w-full  ">
                    {name?.length > 40 ? name.substring(0, 40) + "..." : name}
                  </div>
                </div>
              );
            })}
          {(document.id === "xml" || document.id === "modif_thermal_xml") &&
            document.upload_date && (
              <div className="flex flex-row items-center flex-grow w-full ">
                <div className="text-h4 text-shadow_50 h-4 overflow-hidden flex text-ellipsis gap-1 ">
                  <Icon1 icon_name="date" fill="grey" size={16}></Icon1>{" "}
                  {new Date(
                    document.upload_date.seconds * 1000
                  ).toLocaleString()}
                </div>
              </div>
            )}
        </div>{" "}
      </div>
      <div className="flex flex-row gap-1 items-center  flex-grow  h-6 justify-start">
        {document.icon === "photo" &&
          document.photos?.slice(0, 3).map((photo, index) => (
            <div key={index} className="">
              <Icon1 icon_name="image" size={18} fill="grey" />{" "}
            </div>
          ))}{" "}
        {document.icon === "photo" && document.photos?.length > 3 && (
          <div className="text-h3 text-shadow_50  ml-2 ">
            + {document.photos?.length - 3}
          </div>
        )}
      </div>

      {/* Close Icon (Removable functionality) */}

      <div className="flex flex-row gap-2 items-center justify-end cursor-pointer">
        {checkHasAction() && (
          <Tippy
            className="custom-tooltip"
            content="Action à effectuer"
            placement="top"
            delay={500}
          >
            <div>
              <Icon1 icon_name="warning" size={18} fill="red" />
            </div>
          </Tippy>
        )}
        <div className="flex flex-row gap-2 align-middle items-center ">
          {true && (
            <>
              {action_text() !== "none" &&
                (action_text() === "Ajouter" || action_text() === "Ouvrir") &&
                document.id == "rapport_architecte" &&
                checkIsViewer() && (
                  <Tippy
                    content="Ajouter un rapport architecte"
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div>
                      <UploadRapportArchi
                        folder={folder}
                        onUpdate={onUpdate}
                        prefix={prefix}
                      />
                    </div>
                  </Tippy>
                )}
              {action_text() !== "none" &&
                (action_text() === "Ajouter" || action_text() === "Ouvrir") &&
                document.id == "rapport" &&
                (isFolderAdmin(orgData, folder) ||
                  (!isFolderAdmin(orgData, folder) &&
                    folder.reglement_state === "done")) &&
                checkIsViewer() && (
                  <Tippy
                    content="Ajouter un rapport de fin de chantier"
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div>
                      <UploadRapport
                        folder={folder}
                        onUpdate={onUpdate}
                        prefix={prefix}
                      />{" "}
                    </div>
                  </Tippy>
                )}
              {checkIsViewer()}
              {action_text() !== "none" &&
                (action_text() === "Ajouter" || action_text() === "Ouvrir") &&
                document.id != "thermal" &&
                document.id != "xml" &&
                document.id != "modif_thermal" &&
                document.id != "rapport" &&
                type === "doc" &&
                document.state !== "open" &&
                document.id != "rapport_architecte" &&
                checkIsViewer() && (
                  <Tippy
                    content="Ajouter un document"
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div>
                      <UploadMultiPDF
                        folder={folder}
                        docId={document.id}
                        onUpdate={onUpdate}
                        prefix={prefix}
                      />
                    </div>
                  </Tippy>
                )}

              {document.name === "Formulaire consentement DPE" &&
                document.state === "locked" && (
                  <Tippy
                    content="Ajouter un document"
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div>
                      <UploadMultiPDF
                        folder={folder}
                        docId={document.id}
                        onUpdate={onUpdate}
                        prefix={prefix}
                      />
                    </div>
                  </Tippy>
                )}

              {action_text() !== "none" &&
                (action_text() === "Ajouter" || action_text() === "Ouvrir") &&
                document.id == "modif_thermal" &&
                checkIsViewer() && (
                  <Tippy
                    content="Ajouter un document de mise à jour thermique"
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div>
                      <UploadModifThermal
                        folder={folder}
                        onUpdate={onUpdate}
                        prefix={prefix}
                        handleClickVariant={handleClickVariant}
                      />
                    </div>
                  </Tippy>
                )}

              {action_text() !== "none" &&
                (action_text() === "Ajouter" || action_text() === "Ouvrir") &&
                document.id == "thermal" &&
                checkIsViewer() && (
                  <Tippy
                    content="Ajouter un document thermique"
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div>
                      <UploadThermal
                        folder={folder}
                        onUpdate={onUpdate}
                        prefix={prefix}
                      />
                    </div>
                  </Tippy>
                )}

              {action_text() !== "none" &&
                action_text() === "Ajouter" &&
                (document.id === "xml" ||
                  document.id === "modif_thermal_xml") &&
                checkIsViewer() && (
                  <Tippy
                    content="Ajouter le fichier XML"
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div>
                      <UploadXml2
                        folder={folder}
                        onUpdate={onUpdate}
                        prefix={prefix}
                        modif_thermal_xml={document.id === "modif_thermal_xml"}
                      />
                    </div>
                  </Tippy>
                )}
            </>
          )}
          {folder.modif_thermal.activated &&
            document.state !== "done" &&
            document.id === "modif_thermal" && (
              <div className=" rounded-xl py-0.5 text-accent2  bg-red-100 px-2 text-h2  w-fit">
                Demandé
              </div>
            )}
          {action_text() !== "none" &&
            action_text() !== "Transférer ici" &&
            action_text() !== "Ouvrir" &&
            (action_text() === "Vérifier" || document.icon !== "photo") &&
            action_text() === "Préparer" &&
            document.icon !== "sign" &&
            action_text() !== "Ajouter" && (
              <>
                {document.viewers_id.map((viewer) => viewer.id)}
                <SecondaryButton
                  disabled={!checkIsViewer()}
                  sx={{
                    fontSize: "13px",
                    borderRadius: "8px",
                    minWidth: "80px",
                    backgroundColor: action_background_color,
                    color: action_text_color,
                  }}
                >
                  {action_text()}{" "}
                </SecondaryButton>
              </>
            )}
          {(action_text() === "Ouvrir" || action_text() === "Vérifier") &&
            type !== "photo" &&
            (type === "doc" ||
              type === "thermal" ||
              type === "modif_thermal" ||
              (type === "rapport" &&
                (isFolderAdmin(orgData, folder) ||
                  (isFolderAdmin(orgData, folder) &&
                    folder.reglement_state === "done"))) ||
              type === "rapport_architecte") &&
            type !== "xml" && (
              <PDFModal
                type={type}
                document={document}
                folder={folder}
                onFetch={onUpdate}
                userData={userData}
                prefix={prefix}
                handleDeleteFile={handleDeleteFile}
                orgData={orgData}
                setLoadingData={setLoadingData}
              >
                <SecondaryButton
                  disabled={loadingTransfer === document.id || !checkIsViewer()}
                  sx={{
                    backgroundColor: action_background_color,
                    color: action_text_color,
                  }}
                >
                  {action_text()}
                  <SmallSpinner
                    loading={loadingData === document.id}
                    margin={0}
                    size={20}
                  />
                </SecondaryButton>
              </PDFModal>
            )}

          {type === "photo" && (
            <PhotoModal
              orgData={orgData}
              userData={userData}
              document={document}
              folder={folder}
              onFetch={onUpdate}
              validation={true}
            ></PhotoModal>
          )}
          {action_text() === "Préparer" && document.icon == "sign" && (
            <PdfEditorModal
              document={document}
              folder={folder}
              onFetch={onUpdate}
              userData={userData}
            ></PdfEditorModal>
          )}
          {action_text() === "Préparer" &&
            document.icon === "sign" &&
            document.documentxx?.id === "fffff" &&
            folder.last_file_extracted && (
              <PreSignXmlModal
                document={document}
                folder={folder}
                setModalOpen={setModalOpen}
                orgData={orgData}
                prefix={prefix}
                userData={userData}
                onFetch={onUpdate}
              ></PreSignXmlModal>
            )}
          {action_text() === "Préparer" &&
            document.icon === "sign" &&
            isFolderAdmin(orgData, folder) &&
            (document.documentxx?.id === "hhhhh" ||
              document.documentxx?.id === "lllll") && (
              <SecondaryButton
                className={"w-fit"}
                onClick={() => setGenerateATHSPEOpen(true)}
              >
                Générer
              </SecondaryButton>
            )}
          {action_text() === "Signer" && document.icon == "sign" && (
            <SignModal
              document={document}
              folder={folder}
              onUpdate={onUpdate}
              setModalOpen={setModalOpen}
              orgData={orgData}
              userData={userData}
              prefix={prefix}
              overrideId={overrideId}
              navigateWorkspace={navigateWorkspace}
            ></SignModal>
          )}
          {action_text() !== "none" &&
            (document.id === "xml" || document.id === "modif_thermal_xml") && (
              <div className="flex flex-row gap-2">
                <XmlModal
                  document={document}
                  folder={folder}
                  setModalOpen={setModalOpen}
                  orgData={orgData}
                  userData={userData}
                  prefix={prefix}
                  onFetch={onUpdate}
                  handleAskExpert={handleAskExpert}
                  modif_thermal_xml={document.id === "modif_thermal_xml"}
                ></XmlModal>
              </div>
            )}
          {action_text() !== "none" &&
            action_text() === "Transférer ici" &&
            (isFolderAdmin(orgData, folder) ||
              (!isFolderAdmin(orgData, folder) && document.id !== "rapport")) &&
            (loadingTransfer === undefined ||
              loadingTransfer === null ||
              loadingTransfer === document.id) && (
              <div className="h-full w-fit  rounded-xl shadow-none ">
                <PrimaryButton
                  shimmer={true}
                  className="h-full w-fit  rounded-2xl "
                  onClick={() => handleTransferFiles(document.id)}
                  disabled={
                    (loadingTransfer !== undefined &&
                      loadingTransfer !== null) ||
                    document.state === "open"
                  }
                >
                  <div>
                    <div className="flex flex-row gap-1 items-center">
                      {loadingTransfer === document.id
                        ? "Transfert en cours ..."
                        : action_text()}{" "}
                      <SmallSpinner
                        loading={loadingTransfer === document.id}
                        margin={0}
                        size={20}
                      />
                    </div>
                  </div>
                </PrimaryButton>
              </div>
            )}
          <div
            className=" px-2 w-24 min-w-24 text-center border-1 text-h3 rounded-md text-shadow_50 cursor-default items-center align-middle"
            style={{
              backgroundColor: state_background_color(),
              color: state_color(),
            }}
          >
            {state_text()}
          </div>
          {isFolderAdmin(orgData, folder) && (
            <div className="flex flex-row gap-2 items-center justify-end cursor-pointer">
              <>
                {document.state !== "done" && (
                  <Tippy
                    className="custom-tooltip"
                    content="Valider le document"
                    placement="top"
                    delay={500}
                  >
                    <div onClick={handleValidate}>
                      <Icon1
                        icon_name="done2"
                        hover_color="#0df380"
                        size={18}
                        fill="lightgrey"
                      />
                    </div>
                  </Tippy>
                )}

                {document.state === "done" && (
                  <Tippy
                    className="custom-tooltip"
                    content="Dévalider le document"
                    placement="top"
                    delay={500}
                  >
                    <div onClick={handleValidate}>
                      <Icon1
                        icon_name="done2"
                        hover_color="#f7050c"
                        size={18}
                        fill="lightgrey"
                      />
                    </div>
                  </Tippy>
                )}
              </>
            </div>
          )}
          {!isFolderAdmin(orgData, folder) && (
            <div className="flex flex-row gap-2 items-center justify-end cursor-pointer">
              <>
                {document.state !== "blocked" && (
                  <Tippy
                    className="custom-tooltip"
                    content="Marquer comme impossible à déposer"
                    placement="top"
                    delay={500}
                  >
                    <div onClick={handleBlock}>
                      <Icon1
                        icon_name="forbidden"
                        hover_color="#f7050c"
                        size={18}
                        fill="lightgrey"
                      />
                    </div>
                  </Tippy>
                )}

                {document.state === "blocked" && (
                  <Tippy
                    className="custom-tooltip"
                    content="Enlever le marquage"
                    placement="top"
                    delay={500}
                  >
                    <div onClick={handleBlock}>
                      <Icon1
                        icon_name="forbidden"
                        hover_color="grey"
                        size={18}
                        fill="#f7050c"
                      />
                    </div>
                  </Tippy>
                )}
              </>
            </div>
          )}
          {(document.id === "xml" || document.id === "modif_thermal_xml") &&
            etudeXmlSlot?.file?.id &&
            checkIsViewer() && (
              <div className="flex w-4 min-w-4 items-center">
                {loadingEtude ? (
                  <SmallSpinner loading={loadingEtude} margin={0} size={16} />
                ) : (
                  <Tippy
                    content={
                      etudeXmlSlot?.etude_thermique_file?.id
                        ? "Ouvrir l'étude thermique (PDF)"
                        : "Générer l'étude thermique (RSET complet)"
                    }
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div onClick={handleGenerateEtude}>
                      <Icon1
                        icon_name="pdf"
                        height="16px"
                        width="16px"
                        fill={
                          etudeXmlSlot?.etude_thermique_file?.id
                            ? theme.palette.primary.main
                            : "grey"
                        }
                        hover_color={theme.palette.primary.main}
                      />
                    </div>
                  </Tippy>
                )}
              </div>
            )}
          <div className="flex flex-row gap-1 w-10 min-w-10">
            <div
              className="flex w-4 min-w-4"
              onClick={handleDownload}
              onMouseEnter={() => setDownloadHover(true)}
              onMouseLeave={() => setDownloadHover(false)}
            >
              {" "}
              {((type === "thermal" && folder.thermal.state === "done") ||
                (type === "modif_thermal" &&
                  folder.modif_thermal.state === "done") ||
                (type === "rapport" && folder.rapport.state === "done") ||
                (type === "rapport_architecte" &&
                  folder.rapport_architecte.state === "done") ||
                (type === "modif_thermal_xml" &&
                  folder.modif_thermal?.xml?.state === "done") ||
                (type === "xml" && folder.xml.state === "done") ||
                document.state === "done") &&
                checkIsViewer() && (
                  <Tippy
                    content="Télécharger le document"
                    className="custom-tooltip"
                    delay={500}
                  >
                    <div>
                      <Icon1
                        icon_name="download"
                        height="16px"
                        width="16px"
                        fill={
                          type === "rapport" && folder.reglement_state != "done"
                            ? "red"
                            : onDownloadHover
                              ? "black"
                              : "grey"
                        }
                      />
                    </div>
                  </Tippy>
                )}
            </div>
            <div className="flex ">
              <div
                className="flex "
                onClick={() => setDeleteOpen(true)}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
              >
                {["done", "open", "wait", "missing"].includes(document.state) &&
                  ((document.id === "rapport" &&
                    isFolderAdmin(orgData, folder)) ||
                    (document.id !== "rapport" &&
                      checkIsViewer() &&
                      document.icon !== "photo")) && (
                    <div className="flex flex-row gap-1">
                      {loadingDataDelete === document.id ? (
                        <SmallSpinner
                          loading={loadingDataDelete === document.id}
                          margin={0}
                          size={20}
                        />
                      ) : (
                        <Tippy
                          content="Supprimer le document"
                          className="custom-tooltip"
                          delay={500}
                        >
                          <div>
                            <Icon1
                              icon_name="delete"
                              height="16px"
                              width="16px"
                              fill={
                                isHover
                                  ? theme.palette.accent2.main
                                  : theme.palette.shadow._50
                              }
                            />
                          </div>
                        </Tippy>
                      )}
                    </div>
                  )}
              </div>

              {document.state === "done" &&
                folder.reglement_state !== "done" &&
                document.id === "rapport" &&
                isFolderClient(orgData, folder) && (
                  <div className="w-4 min-w-4 " onClick={sendLockedNotif}>
                    <Icon1
                      icon_name="lock"
                      height="16px"
                      width="16px"
                      fill={theme.palette.accent2.main}
                    />{" "}
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentCell;
